/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PreSearchDataItem,
    PreSearchDataItemFromJSON,
    PreSearchDataItemFromJSONTyped,
    PreSearchDataItemToJSON,
    ProviderRequestResponseItem,
    ProviderRequestResponseItemFromJSON,
    ProviderRequestResponseItemFromJSONTyped,
    ProviderRequestResponseItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface ShoppingDiagnosticsData
 */
export interface ShoppingDiagnosticsData {
    /**
     * 
     * @type {string}
     * @memberof ShoppingDiagnosticsData
     */
    apiRequest?: string | null;
    /**
     * 
     * @type {Array<PreSearchDataItem>}
     * @memberof ShoppingDiagnosticsData
     */
    preSearchData?: Array<PreSearchDataItem> | null;
    /**
     * 
     * @type {Array<ProviderRequestResponseItem>}
     * @memberof ShoppingDiagnosticsData
     */
    shoppingRequestResponseData?: Array<ProviderRequestResponseItem> | null;
    /**
     * 
     * @type {Array<ProviderRequestResponseItem>}
     * @memberof ShoppingDiagnosticsData
     */
    pricingRequestResponseData?: Array<ProviderRequestResponseItem> | null;
    /**
     * 
     * @type {Array<ProviderRequestResponseItem>}
     * @memberof ShoppingDiagnosticsData
     */
    bookingRequestResponseData?: Array<ProviderRequestResponseItem> | null;
    /**
     * 
     * @type {Array<ProviderRequestResponseItem>}
     * @memberof ShoppingDiagnosticsData
     */
    cancelRequestResponseData?: Array<ProviderRequestResponseItem> | null;
    /**
     * 
     * @type {Array<ProviderRequestResponseItem>}
     * @memberof ShoppingDiagnosticsData
     */
    updateRequestResponseData?: Array<ProviderRequestResponseItem> | null;
    /**
     * 
     * @type {Array<ProviderRequestResponseItem>}
     * @memberof ShoppingDiagnosticsData
     */
    retrieveRequestResponseData?: Array<ProviderRequestResponseItem> | null;
    /**
     * 
     * @type {Array<ProviderRequestResponseItem>}
     * @memberof ShoppingDiagnosticsData
     */
    fareRulesRequestResponseData?: Array<ProviderRequestResponseItem> | null;
    /**
     * 
     * @type {Array<ProviderRequestResponseItem>}
     * @memberof ShoppingDiagnosticsData
     */
    virtualCardRequestResponseData?: Array<ProviderRequestResponseItem> | null;
    /**
     * 
     * @type {Array<ProviderRequestResponseItem>}
     * @memberof ShoppingDiagnosticsData
     */
    updatePricingRequestResponseData?: Array<ProviderRequestResponseItem> | null;
    /**
     * 
     * @type {Array<ProviderRequestResponseItem>}
     * @memberof ShoppingDiagnosticsData
     */
    ticketingRequestResponseData?: Array<ProviderRequestResponseItem> | null;
    /**
     * 
     * @type {number}
     * @memberof ShoppingDiagnosticsData
     */
    excludedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingDiagnosticsData
     */
    keptCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShoppingDiagnosticsData
     */
    exclusionReasons?: Array<string> | null;
}

export function ShoppingDiagnosticsDataFromJSON(json: any): ShoppingDiagnosticsData {
    return ShoppingDiagnosticsDataFromJSONTyped(json, false);
}

export function ShoppingDiagnosticsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShoppingDiagnosticsData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'apiRequest': !exists(json, 'apiRequest') ? undefined : json['apiRequest'],
        'preSearchData': !exists(json, 'preSearchData') ? undefined : (json['preSearchData'] === null ? null : (json['preSearchData'] as Array<any>).map(PreSearchDataItemFromJSON)),
        'shoppingRequestResponseData': !exists(json, 'shoppingRequestResponseData') ? undefined : (json['shoppingRequestResponseData'] === null ? null : (json['shoppingRequestResponseData'] as Array<any>).map(ProviderRequestResponseItemFromJSON)),
        'pricingRequestResponseData': !exists(json, 'pricingRequestResponseData') ? undefined : (json['pricingRequestResponseData'] === null ? null : (json['pricingRequestResponseData'] as Array<any>).map(ProviderRequestResponseItemFromJSON)),
        'bookingRequestResponseData': !exists(json, 'bookingRequestResponseData') ? undefined : (json['bookingRequestResponseData'] === null ? null : (json['bookingRequestResponseData'] as Array<any>).map(ProviderRequestResponseItemFromJSON)),
        'cancelRequestResponseData': !exists(json, 'cancelRequestResponseData') ? undefined : (json['cancelRequestResponseData'] === null ? null : (json['cancelRequestResponseData'] as Array<any>).map(ProviderRequestResponseItemFromJSON)),
        'updateRequestResponseData': !exists(json, 'updateRequestResponseData') ? undefined : (json['updateRequestResponseData'] === null ? null : (json['updateRequestResponseData'] as Array<any>).map(ProviderRequestResponseItemFromJSON)),
        'retrieveRequestResponseData': !exists(json, 'retrieveRequestResponseData') ? undefined : (json['retrieveRequestResponseData'] === null ? null : (json['retrieveRequestResponseData'] as Array<any>).map(ProviderRequestResponseItemFromJSON)),
        'fareRulesRequestResponseData': !exists(json, 'fareRulesRequestResponseData') ? undefined : (json['fareRulesRequestResponseData'] === null ? null : (json['fareRulesRequestResponseData'] as Array<any>).map(ProviderRequestResponseItemFromJSON)),
        'virtualCardRequestResponseData': !exists(json, 'virtualCardRequestResponseData') ? undefined : (json['virtualCardRequestResponseData'] === null ? null : (json['virtualCardRequestResponseData'] as Array<any>).map(ProviderRequestResponseItemFromJSON)),
        'updatePricingRequestResponseData': !exists(json, 'updatePricingRequestResponseData') ? undefined : (json['updatePricingRequestResponseData'] === null ? null : (json['updatePricingRequestResponseData'] as Array<any>).map(ProviderRequestResponseItemFromJSON)),
        'ticketingRequestResponseData': !exists(json, 'ticketingRequestResponseData') ? undefined : (json['ticketingRequestResponseData'] === null ? null : (json['ticketingRequestResponseData'] as Array<any>).map(ProviderRequestResponseItemFromJSON)),
        'excludedCount': !exists(json, 'excludedCount') ? undefined : json['excludedCount'],
        'keptCount': !exists(json, 'keptCount') ? undefined : json['keptCount'],
        'exclusionReasons': !exists(json, 'exclusionReasons') ? undefined : json['exclusionReasons'],
    };
}

export function ShoppingDiagnosticsDataToJSON(value?: ShoppingDiagnosticsData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'apiRequest': value.apiRequest,
        'preSearchData': value.preSearchData === undefined ? undefined : (value.preSearchData === null ? null : (value.preSearchData as Array<any>).map(PreSearchDataItemToJSON)),
        'shoppingRequestResponseData': value.shoppingRequestResponseData === undefined ? undefined : (value.shoppingRequestResponseData === null ? null : (value.shoppingRequestResponseData as Array<any>).map(ProviderRequestResponseItemToJSON)),
        'pricingRequestResponseData': value.pricingRequestResponseData === undefined ? undefined : (value.pricingRequestResponseData === null ? null : (value.pricingRequestResponseData as Array<any>).map(ProviderRequestResponseItemToJSON)),
        'bookingRequestResponseData': value.bookingRequestResponseData === undefined ? undefined : (value.bookingRequestResponseData === null ? null : (value.bookingRequestResponseData as Array<any>).map(ProviderRequestResponseItemToJSON)),
        'cancelRequestResponseData': value.cancelRequestResponseData === undefined ? undefined : (value.cancelRequestResponseData === null ? null : (value.cancelRequestResponseData as Array<any>).map(ProviderRequestResponseItemToJSON)),
        'updateRequestResponseData': value.updateRequestResponseData === undefined ? undefined : (value.updateRequestResponseData === null ? null : (value.updateRequestResponseData as Array<any>).map(ProviderRequestResponseItemToJSON)),
        'retrieveRequestResponseData': value.retrieveRequestResponseData === undefined ? undefined : (value.retrieveRequestResponseData === null ? null : (value.retrieveRequestResponseData as Array<any>).map(ProviderRequestResponseItemToJSON)),
        'fareRulesRequestResponseData': value.fareRulesRequestResponseData === undefined ? undefined : (value.fareRulesRequestResponseData === null ? null : (value.fareRulesRequestResponseData as Array<any>).map(ProviderRequestResponseItemToJSON)),
        'virtualCardRequestResponseData': value.virtualCardRequestResponseData === undefined ? undefined : (value.virtualCardRequestResponseData === null ? null : (value.virtualCardRequestResponseData as Array<any>).map(ProviderRequestResponseItemToJSON)),
        'updatePricingRequestResponseData': value.updatePricingRequestResponseData === undefined ? undefined : (value.updatePricingRequestResponseData === null ? null : (value.updatePricingRequestResponseData as Array<any>).map(ProviderRequestResponseItemToJSON)),
        'ticketingRequestResponseData': value.ticketingRequestResponseData === undefined ? undefined : (value.ticketingRequestResponseData === null ? null : (value.ticketingRequestResponseData as Array<any>).map(ProviderRequestResponseItemToJSON)),
        'excludedCount': value.excludedCount,
        'keptCount': value.keptCount,
        'exclusionReasons': value.exclusionReasons,
    };
}


